import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {PaginationBar} from '@/components/ui/pagination-bar'
import {useEmployeeDesignations} from '@/hooks/sgsst/evaluacion/use-designations'
import {formatDateOnly} from '@/lib/risk'

export function EmployeeDesignationsSection({businessId, employeeId}: {businessId: string; employeeId: string | null}) {
  const {t} = useTranslation()
  const [page, setPage] = useState(1)
  const {data: years} = useEmployeeDesignations(businessId, employeeId, page)
  if (!years?.total) return null
  return (
    <div className="space-y-4 border-t border-border pt-3">
      {years.items.map((year) => (
        <section key={year.year}>
          <p className="font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
            {year.year} · {t('designations.sectionLabel')}
            {year.is_closed && ` · ${t('sgsst.cycle.closed')}`}
          </p>
          <ul className="mt-1">
            {year.items.map((item) => (
              <li
                key={item.id}
                className="flex items-baseline gap-3 border-b border-border py-2 text-sm last:border-b-0">
                <span className="w-12 shrink-0 font-mono text-xs font-medium text-primary">{item.standard_code}</span>
                <span className="min-w-0 flex-1 truncate font-medium text-foreground">
                  {t('designations.since', {date: formatDateOnly(item.effective_date)})}
                </span>
                {item.party && <Tag tone="neutral">{t(`designations.party.${item.party}`)}</Tag>}
                {item.rol && <Tag tone="neutral">{t(`designations.rol.${item.rol}`)}</Tag>}
                {item.pending_confirmation && <Tag tone="amber">{t('designations.pendingTag')}</Tag>}
              </li>
            ))}
          </ul>
        </section>
      ))}
      <PaginationBar page={years.page} pageSize={years.page_size} total={years.total} onPageChange={setPage} />
    </div>
  )
}
